export const overlayTransitionDuration = 300;
export var localStorageKeys;
(function (localStorageKeys) {
    localStorageKeys["showInfoBox"] = "vch-player_show-info-box";
})(localStorageKeys || (localStorageKeys = {}));
